<script>
import { mapActions, mapState } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';

export default {
  name: 'FerryCarTypeAdd',
  mixins: [
    validatorMixin,
  ],
  props: {
    shown: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      validForm: true,
      car: null,
    };
  },
  computed: {
    ...mapState({
      saveError: state => state.transportation.carTypes.saveError,
      saveLoading: state => state.transportation.carTypes.saveLoading,
    }),
  },
  methods: {
    ...mapActions({
      addCarType: 'transportation/carTypesAdd',
    }),
    saveCarType() {
      if (this.validForm) {
        this.addCarType(this.car)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
    resetCar() {
      this.car = {
        name: null,
        length: null,
        height: null,
        webName: null,
        externalRef: null,
        active: false,
      };
    },
  },
  watch: {
    shown() {
      if (this.shown) {
        this.$refs.addCarTypeForm.resetValidation();
        this.resetCar();
      }
    },
  },
  created() {
    this.resetCar();
  },
};
</script>

<template>
  <v-card>
    <v-form v-model="validForm" @submit.prevent="saveCarType" ref="addCarTypeForm">
      <v-card-title>
        <v-layout wrap>
          <h2>Add car type</h2>
          <v-flex xs12>
            Please note that the car type will be automatically created for all domains and the web name translated using DeepL
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          v-if="saveLoading"
          :active="saveLoading"
          :height="4"
          class="my-0"
          indeterminate
        />
        <v-alert
          v-if="!saveLoading"
          :value="!!saveError"
          class="my-0 py-2"
          transition="slide-y-transition"
          outline
        >
          The car type could not be saved - please reload the page and try again
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="car.name"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Supplier name"
              />
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="car.externalRef"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="External reference"
              />
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="car.height"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Height (in cm)"
                type="number"
              />
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="car.length"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Length (in cm)"
                type="number"
              />
            </v-flex>
          </v-layout>

          <v-layout row mt-3>
            <v-flex xs12>
              <v-text-field
                v-model="car.webName"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Web Name"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                v-model="car.active"
                :disabled="saveLoading"
                label="Active"
                class="mt-0"
                hide-details
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          @click="$emit('close')"
          color="red darken-1"
          flat
        >
          Cancel
        </v-btn>
        <v-spacer/>
        <v-tooltip top>
          <template slot="activator" slot-scope="{ on }">
            <div v-on="on">
              <v-btn
                :disabled="!validForm || saveLoading"
                color="blue darken-1"
                type="submit"
                flat
              >
                Save
              </v-btn>
            </div>
          </template>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationCarTypesAdd.vue